module.exports = __webpack_public_path__ + "img/dingzhiyansechoubiandaiWu.min.07ca198f.png";